<div
  *ngIf="filteredFundPerformances?.length"
  data-qa="period-picker-internal"
  class="picker flex flex-col"
  (mouseenter)="activateDropDown()"
  (mouseleave)="deactivateDropDown()">
  <span class="picker-header">Period</span>
  <div class="picker-name centered-row-container">
    <span class="centered-row-container">
      <app-all-icons
        *ngIf="selectedFundPerformance?.isPublished"
        data-qa="selected-period-published"
        [iconNameAndStyling]="'paper-plane.svg'">
      </app-all-icons>
      <app-all-icons
        *ngIf="isMultiAccess && userType === 'admin' && selectedFundPerformance?.isBasedOnPrognosis"
        data-qa="selected-period-predicted"
        [iconNameAndStyling]="'prediction.svg'">
      </app-all-icons>
      <app-all-icons
        *ngIf="isMultiAccess && userType === 'admin' && (selectedFundPerformance?.blocked || fsNavData.isCompleted)"
        data-qa="selected-period-blocked"
        [iconNameAndStyling]="'lock-closed-fill.svg'">
      </app-all-icons>
      <app-all-icons
        *ngIf="!selectedFundPerformance?.isVisible"
        data-qa="selected-period-visible"
        [iconNameAndStyling]="'crossed-eye.svg'">
      </app-all-icons>
      <div *ngIf="isMultiAccess && userType === 'admin' && selectedFundPerformance?.blocked"
        class="xAxis-whitespace-0p375">
      </div>
      <div *ngIf="currentService !== 'FS'"
        data-qa="selected-period">
        {{ (selectedFundPerformance?.period && filteredFundPerformances?.length) ? selectedFundPerformance?.period : "Period" }}
      </div>
      <div *ngIf="currentService === 'FS'"
        data-qa="fs-selected-period">
        {{ fsNavData.selectedPeriod?.period ?? "Period" }}
      </div>
    </span>
    <div class="xAxis-whitespace-xtiny"></div>
    <app-all-icons
      [iconNameAndStyling]="'arrow-down.svg;icon-size-1p25'">
    </app-all-icons>
  </div>
  <div
    *ngIf="showPicker.fp.isShown"
    @fadeInOut
    class="picker-dropdown centered-column-container">
    <div data-qa="periods-picker-list"
         class="centered-column-container picker-list">
      <div class="centered-column-container list-block">
        <div
          *ngIf="userType === 'admin'"
          data-qa="periods-picker-list-add-button"
          class="list-entry row-gap-0p5 main-8"
          (click)="actionEmitter.emit(ACTION_FLAG.COPY)">
          <app-all-icons [iconNameAndStyling]="'plus.svg'"/>
          <span>Period</span>
        </div>
        <span *ngFor="let f of filteredFundPerformances; let i = index"
          data-qa="periods-picker-list-period"
          class="list-entry"
          [class.selected]="f.period === selectedFundPerformance?.period">
          <div *ngIf="f.period === selectedFundPerformance?.period; else notSelectedPeriod"
            [attr.data-qa]="'period-list-entry-'+f.period"
            class="space-between-horizontal width-100pcnt">
            <div (click)="switchFp(f)">
              {{ f.period }}
            </div>
            <div *ngIf="isMultiAccess &&
              (selectedFundPerformance.isBasedOnPrognosis || userType === 'admin')  &&
               showElements.showPortfolio"
               class="centered-row-container"
               [class.row-gap-0p375]="userType === 'admin'">
              <div data-qa="published-period-icon">
                <app-all-icons
                  class="cursor-default"
                  [id]="'published-'+i"
                  [iconNameAndStyling]="f?.isPublished ? 'paper-plane.svg; icon-selected main-8' : 'paper-plane.svg; black-9 ' + ' hornav-icon br-0p25'"
                  (mouseenter)="activateTooltip('published-' + i, selectedFundPerformance)"
                  (mouseleave)="hideTooltip()">
                </app-all-icons>
              </div>
              <div data-qa="predict-period" (click)="toggleIsPeriodPredicted(selectedFundPerformance)">
                <app-all-icons
                  [id]="'predicted-'+i"
                  [iconNameAndStyling]="'prediction.svg; hornav-icon br-0p25 ' + (selectedFundPerformance.isBasedOnPrognosis ? 'icon-selected main-8' : 'black-9')"
                  (mouseenter)="activateTooltip('predicted-' + i, selectedFundPerformance)"
                  (mouseleave)="hideTooltip()">
                </app-all-icons>
              </div>
              <div *ngIf="isMultiAccess && userType === 'admin' && showElements.showPortfolio"
                class="centered-row-container row-gap-0p375">
                <div
                  [attr.data-qa]="selectedFundPerformance?.blocked ? 'unblock-period' : 'block-period'"
                  (click)="actionEmitter.emit(ACTION_FLAG.BLOCK)">
                  <app-all-icons
                    [id]="'locked-' + i"
                    [iconNameAndStyling]="selectedFundPerformance?.blocked ? 'lock-closed-empty.svg; icon-selected main-8' : 'lock-opened-empty.svg; black-9' + ' hornav-icon br-0p25'"
                    (mouseenter)="activateTooltip('locked-' + i, selectedFundPerformance)"
                    (mouseleave)="hideTooltip()">
                  </app-all-icons>
                </div>
                <div
                  data-qa="visible-period"
                  [class.cursor-default]="f.isPublished"
                  (click)="togglePeriodVision(f)">
                  <app-all-icons
                    [id]="'visible-'+i"
                    [iconNameAndStyling]="(!selectedFundPerformance?.isVisible ? 'crossed-eye.svg; main-8 icon-selected' : 'eye.svg; black-9') + ' hornav-icon br-0p25'"
                    (mouseenter)="activateTooltip('visible-' + i, selectedFundPerformance)"
                    (mouseleave)="hideTooltip()">
                  </app-all-icons>
                </div>
                <app-all-icons
                  data-qa="copy-period"
                  [id]="'copy-'+i"
                  [iconNameAndStyling]="'copy.svg; hornav-icon br-0p25'"
                  (mouseenter)="activateTooltip('copy-' + i, selectedFundPerformance)"
                  (mouseleave)="hideTooltip()"
                  (click)="actionEmitter.emit(ACTION_FLAG.COPY)">
                </app-all-icons>
                <app-all-icons
                  data-qa="delete-period"
                  [id]="'delete-'+i"
                  [iconNameAndStyling]="'delete-outline.svg; hornav-icon br-0p25'"
                  (mouseenter)="activateTooltip('delete-' + i, selectedFundPerformance)"
                  (mouseleave)="hideTooltip()"
                  (click)="actionEmitter.emit(ACTION_FLAG.DELETE)">
                </app-all-icons>
              </div>
            </div>
          </div>
          <ng-template #notSelectedPeriod>
            <div [attr.data-qa]="'period-list-entry-'+f.period"
                 class="space-between-horizontal width-100pcnt">
              <div class="width-100pcnt" (click)="switchFp(f)">
                {{ f.period }}
              </div>
              <div *ngIf="f.isPublished"
                   data-qa="published-period-icon"
                   class="cursor-default">
                <app-all-icons
                  [id]="'published-'+i"
                  [iconNameAndStyling]="'paper-plane.svg; hornav-icon br-0p25 icon-selected main-8'"
                  (mouseenter)="activateTooltip('published-' + i, f)"
                  (mouseleave)="hideTooltip()">
                </app-all-icons>
              </div>
              <div *ngIf="f?.isBasedOnPrognosis"
                   data-qa="predicted-period-icon"
                   class="cursor-default">
                <app-all-icons
                  [id]="'predicted-'+i"
                  [iconNameAndStyling]="'prediction.svg; hornav-icon br-0p25 icon-selected main-8'"
                  (mouseenter)="activateTooltip('predicted-' + i, f)"
                  (mouseleave)="hideTooltip()">
                </app-all-icons>
              </div>
              <div *ngIf="userType === 'admin' && f?.blocked"
                   data-qa="locked-period-icon"
                   class="cursor-default">
                <app-all-icons
                  [id]="'locked-'+i"
                  [iconNameAndStyling]="'lock-closed-empty.svg; hornav-icon br-0p25 icon-selected main-8'"
                  (mouseenter)="activateTooltip('locked-' + i, f)"
                  (mouseleave)="hideTooltip()">
                </app-all-icons>
              </div>
              <div *ngIf="userType === 'admin' && !f?.isVisible"
                   data-qa="visible-period-icon"
                   class="cursor-default">
                <app-all-icons
                  [id]="'visible-'+i"
                  [iconNameAndStyling]="'crossed-eye.svg; hornav-icon br-0p25 icon-selected main-8'"
                  (mouseenter)="activateTooltip('visible-' + i, f)"
                  (mouseleave)="hideTooltip()">
                </app-all-icons>
              </div>
            </div>
          </ng-template>
        </span>
      </div>
    </div>
  </div>
  <div
    *ngIf="showPicker.fs.isShown"
    @fadeInOut
    class="picker-dropdown centered-column-container">
    <div [attr.data-qa]="'fs-periods-picker-list'"
      class="picker-list">
      <div class="list-block">
        <span *ngIf="isManagementEntity"
          class="list-entry centered-row-container">
          <app-button
            data-qa="create-new-period-button"
            [type]="'white-green'"
            [size]="'small'"
            [iconName]="'plus.svg'"
            (click)="showCreatePeriodModal()">
            Create period
          </app-button>
        </span>
        <span *ngFor="let f of fsNavData.periods; let i = index"
          [attr.data-qa]="'fs-periods-picker-list-period'"
          class="list-entry"
          [class.selected]="f.period === fsNavData.selectedPeriod.period">
          <div class="space-between-horizontal width-100pcnt">
            <div [attr.data-qa]="'fs-period-list-entry-'+f.period" [class.width-100pcnt]="f.period !== fsNavData.selectedPeriod.period"
              (click)="switchFsPeriod(f)">
              {{ f.period }}
            </div>
            <div *ngVar="f.period === fsNavData.selectedPeriod.period as isSelectedPeriod"
              class="centered-row-container row-gap-0p375">
              <div *ngIf="userType === 'admin' && isSelectedPeriod && f.status !== FsStatus.none"
                class="centered-row-container row-gap-0p375">
                <app-all-icons
                  [attr.data-qa]="'copy-period-' + f.period"
                  [id]="'copy-'+i"
                  [iconNameAndStyling]="'copy.svg; hornav-icon; br-0p25'"
                  [class.disabled-icon]="f.status === FsStatus.completed"
                  [class.no-propagation]="f.status === FsStatus.completed"
                  (click)="copyFsPeriod()">
                </app-all-icons>
                <app-all-icons
                  [attr.data-qa]="'delete-period-data-' + f.period"
                  [id]="'delete-'+i"
                  [iconNameAndStyling]="'delete-outline.svg; hornav-icon; br-0p25'"
                  [class.disabled-icon]="f.status === FsStatus.completed"
                  [class.no-propagation]="f.status === FsStatus.completed"
                  (click)="!isManagementEntity ? deleteFsPeriodData() : showPicker.fs.deleteMenu = true">
                </app-all-icons>
                <div *ngIf="showPicker.fs.deleteMenu"
                  class="z-35 position-abs centered-column-container box-shadow"
                  (mouseleave)="showPicker.fs.deleteMenu = false">
                  <ul class="list">
                    <app-drop-down-item
                      data-qa="delete-period-data-list"
                      class="width-100pcnt"
                      [text]="'Clear data'"
                      [menuItemClass]="'red'"
                      [iconNameAndStyling]="'delete.svg'"
                      (click)="deleteFsPeriodData()">
                    </app-drop-down-item>
                    <app-drop-down-item
                      data-qa="fs-delete-period-list"
                      class="width-100pcnt"
                      [text]="'Delete period'"
                      [menuItemClass]="'red'"
                      [iconNameAndStyling]="'delete.svg'"
                      (click)="deleteFsPeriod(f)">
                    </app-drop-down-item>
                  </ul>
                </div>
              </div>
              <app-all-icons
                *ngIf="isManagementEntity && f.status === FsStatus.none"
                [attr.data-qa]="'delete-empty-period-' + f.period"
                [id]="'delete-'+i"
                [iconNameAndStyling]="'delete-outline.svg; hornav-icon; br-0p25'"
                (click)="deleteFsPeriod(f)">
              </app-all-icons>
              <div *ngIf="f.status !== FsStatus.none" class="centered-row-container row-gap-0p375">
                <app-all-icons
                  [attr.data-qa]="'lock-period-' + f.period"
                  [id]="'locked-'+i"
                  [iconNameAndStyling]="f.status === FsStatus.completed ? 'lock-closed-empty.svg; br-0p25' :
                    'lock-opened-empty.svg; hornav-icon; br-0p25'"
                  (click)="changeFsStatus(f)">
                </app-all-icons>
              </div>
            </div>
          </div>
        </span>
      </div>
    </div>
  </div>
</div>

<app-tooltip
  *ngIf="toolTipSettings.show"
  [dataQa]="'period-picker-tooltip'"
  [coordinates]="toolTipSettings.coordinates"
  [isParentPositionRelative]="true"
  [title]="toolTipSettings.title">
</app-tooltip>
